import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  useGetFormDataQuery,
  useUpdateLotPrefixDataMutation,
  useGetBasicLotPrefixDataQuery,
} from "../../../../store/queries/Master";
// import { updateConfig } from "../../../../store/slices/Master/LotPrefix/lotPrefixSlice.js";
import {updateConfig} from "../../../../store/slices/Master/CertificatePrefix/certificatePrefixSlice"
import countryData from "../../../../utils/components/countryCode";

const useAddLotPrefix = ({ refetch }) => {
  const dispatch = useDispatch();
  const [dhcChecked, setDhcChecked] = useState(false);
  const [supplierChecked, setSupplierChecked] = useState(false);
  const [priceOrCodeChecked, setPriceOrCodeChecked] = useState(false);
  const [certificationChecked, setCertificationChecked] = useState(false);
  const [dhcBranchChecked, setDhcBranchChecked] = useState(false);
  const [shopChecked, setShopChecked] = useState(false);
  const [countryChecked, setCountryChecked] = useState(false);
  const [itemTypeChecked, setItemTypeChecked] = useState(false);
  const [dayChecked, setDayChecked] = useState(false);
  const [monthChecked, setMonthChecked] = useState(false);
  const [yearChecked, setYearChecked] = useState(false);
  const [goldBasedChecked, setGoldBasedChecked] = useState(false);
  const [platinumBasedChecked, setPlatinumBasedChecked] = useState(false);
  const [exampleText, setExampleText] = useState("");

  const { lotPrefixData, isEdit } = useSelector(
    (state) => state.certificatePrefix
  );

  const { data: formData = {}, isLoading } = useGetFormDataQuery();
  const { data: basicData = {} } = useGetBasicLotPrefixDataQuery();
  const [updateLotPrefixData] =
    useUpdateLotPrefixDataMutation();

  const optionsArray = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    { label: 8, value: 8 },
    { label: 9, value: 9 },
    { label: 10, value: 10 },
    { label: 11, value: 11 },
    { label: 12, value: 12 },
  ];
  const [selectedOrders, setSelectedOrders] = useState({});

  const [filteredOptions, setFilteredOptions] = useState(optionsArray);

  const checkboxFields = [
    {
      id: "dhc",
      label: "DHC",
      state: dhcChecked,
      setState: setDhcChecked,
      name: "dhc_order",
    },
    {
      id: "supplier",
      label: "Supplier",
      state: supplierChecked,
      setState: setSupplierChecked,
      name: "supplier_order",
    },
    {
      id: "dhc_branch",
      label: "DHC Branch",
      state: dhcBranchChecked,
      setState: setDhcBranchChecked,
      name: "dhc_branch_order",
    },
    {
      id: "shop",
      label: "Shop",
      state: shopChecked,
      setState: setShopChecked,
      name: "shop_order",
    },
    {
      id: "country",
      label: "Country",
      state: countryChecked,
      setState: setCountryChecked,
      name: "country_order",
    },
    {
      id: "item_type",
      label: "Item",
      state: itemTypeChecked,
      setState: setItemTypeChecked,
      name: "item_type_order",
    },
    {
      id: "price_or_code",
      label: "Price or Code",
      state: priceOrCodeChecked,
      setState: setPriceOrCodeChecked,
      name: "price_or_code_order",
    },
    {
      id: "certification",
      label: "Certification",
      state: certificationChecked,
      setState: setCertificationChecked,
      name: "certification_order",
    },
  ];

  const keyFunctionMap = {
    dhc: (value) => {
      setDhcChecked(true);
      setOrderValue("dhc", value);
    },
    supplier: (value) => {
      setSupplierChecked(true);
      setOrderValue("supplier", value);
    },
    price_or_code: (value) => {
      setPriceOrCodeChecked(true);
      setOrderValue("price_or_code", value);
    },
    certification: (value) => {
      setCertificationChecked(true);
      setOrderValue("certification", value);
    },
    dhc_branch: (value) => {
      setDhcBranchChecked(true);
      setOrderValue("dhc_branch", value);
    },
    shop: (value) => {
      setShopChecked(true);
      setOrderValue("shop", value);
    },
    country: (value) => {
      setCountryChecked(true);
      setOrderValue("country", value);
    },
    item_type: (value) => {
      setItemTypeChecked(true);
      setOrderValue("item_type", value);
    },
    day: (value) => {
      setOrderValue("day", value);
      setDayChecked(true);
    },
    month: (value) => {
      setOrderValue("month", value);
      setMonthChecked(true);
    },
    year: (value) => {
      setOrderValue("year", value);
      setYearChecked(true);
    },
     shop_prefix: (value) => {
      setOrderValue("shop_lot_prefix", value);
    },
    serial_number: (value) => {
      setOrderValue("serial_number", value);
    },
      shop_lot_prefix: (value) => {
      setOrderValue("shop_lot_prefix", value);
    },
  };

  useEffect(() => {
    if (lotPrefixData && isEdit) {
      Object.keys(lotPrefixData || {}).forEach((key) => {
        if (key === "character") {
          formik?.setFieldValue("character", lotPrefixData?.[key]);
        }
        if (key === "shop_id") {
          const result = basicData?.data?.shop.filter(
            (value) => value?._id === lotPrefixData?.[key]
          )?.[0];

          if (result) {
            formik?.setFieldValue("shop_id", result);
          }
        } 
        if (key === "status") {
          const result = basicData?.data?.status_list.filter(
            (value) => value?.id === lotPrefixData?.[key]
          )?.[0];

          if (result) {
            formik?.setFieldValue("status", result);
          }
        } else if (key === "serial_number_reset") {
          const result = basicData?.data?.serial_number_reset.find(
            (value) => value?.id === lotPrefixData?.[key]
          );
          formik?.setFieldValue("serial_number_reset", result);
        } else if (key === "serial_number_basis") {
          const result = basicData?.data?.serial_number_basis.find(
            (value) => value?.id === lotPrefixData?.[key]
          );
          formik?.setFieldValue("serial_number_basis", result);
        } else if (key === "gold_based") {
          setGoldBasedChecked(!!lotPrefixData?.[key]);
        } else if (key === "platinum_based") {
          setPlatinumBasedChecked(!!lotPrefixData?.[key]);
        } else if (key === "shop_lot_prefix") {
          formik?.setFieldValue("shop_lot_prefix", lotPrefixData?.[key]);
        } else if (key === "serial_number") {
          formik?.setFieldValue("serial_number", lotPrefixData?.[key]);
        } else if (key === "day") {
          const result = basicData?.data?.day.find(
            (value) => value?.id === lotPrefixData?.[key]
          );
          setDayChecked(true);
          formik?.setFieldValue("day", result);
        } else if (key === "month") {
          const result = basicData?.data?.day.find(
            (value) => value?.id === lotPrefixData?.[key]
          );
          setMonthChecked(true);
          formik?.setFieldValue("month", result);
        } else if (key === "year_type") {
          const result = basicData?.data?.year_type?.filter(
            (val) => val?.id === lotPrefixData?.[key]
          )?.[0];
          formik?.setFieldValue(key, result);
        } else if (key === "year_character") {
          formik?.setFieldValue("year_char", lotPrefixData?.[key]);
        } else if (key === "year") {
          const result = basicData?.data?.year.find(
            (value) => value?.id === lotPrefixData?.[key]
          );
          setYearChecked(true);
          formik?.setFieldValue("year", result);
        } else if (key === "branch_prefix") {
          formik?.setFieldValue(
            "certificate_prefix_text",
            lotPrefixData?.[key]
          );
        } else if (key === "branch_id") {
          const result = basicData?.data?.branch?.filter(
            (val) => val?._id === lotPrefixData?.[key]
          )?.[0];

          formik?.setFieldValue("selected_dhc_branch", result);
        } else if (key === "format_type") {
          formik?.setFieldValue("format_type", lotPrefixData?.[key]);
        } else if (key === "prefix_order") {
          const newOrders = {};
          lotPrefixData?.[key].forEach((item) => {
            
            const [key, value] = Object.entries(item)[0];
            newOrders[`${key}_order`] = value;
            if (keyFunctionMap.hasOwnProperty(key)) {
              keyFunctionMap[key](value);
            }
          });
          
          setSelectedOrders(newOrders);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotPrefixData, isLoading, basicData]);

  

  const validation = Yup.object({
    // shop_id:
    //   certificatePrefixData?.format_type !== 1 &&
    //   !isEdit &&
    //   Yup.object().required("Select Shop"),
    serial_number_reset: Yup.object().required("Select Serial number reset"),
    status: Yup.object().required("Select One"),
    serial_number_basis: Yup.object().required("Select Serial number basis"),
    day: dayChecked && Yup.object().required("Select Day"),
    month: monthChecked && Yup.object().required("Select Month"),
    // year: yearChecked && Yup.object().required("Select Year"),
    // gold_based:
    //   !goldBasedChecked && !platinumBasedChecked
    //     ? Yup.boolean().required("Please choose either Gold or platinum based")
    //     : undefined,

    serial_number: !isEdit
      ? Yup.string()
          .required("Enter Serial Number")
          .max(6, "Maximum 6 digits allowed")
          .matches(/^[0-9]*$/, "Enter valid serial number")
      : undefined,

       shop_lot_prefix: !isEdit
      ? Yup.string()
          .required("Enter Lot Prefix")
          // .max(6, "Maximum 6 digits allowed")
          // .matches(/^[0-9]*$/, "Enter valid serial number")
      : undefined,
  });

  const formik = useFormik({
    initialValues: {
      format_type: 2,
      certificate_prefix_id: "",
      status: "",
      shop_id: "",
      dhc: "",
      supplier: "",
      price_or_code: "",
      certification: "",
      dhc_branch: "",
      shop: true,
      country: "",
      item_type: "",
      day: "",
      month: "",
      year: "",
      gold_based: "",
      platinum_based: "",
      serial_number: "",
      shop_lot_prefix:"",
      serial_number_reset: basicData?.data?.serial_number_reset?.[2]?? "",
      serial_number_basis: basicData?.data?.serial_number_basis?.[1] ?? "",
      // prefix_order: [],
      prefix_order: ["serial_number", "shop"],
      dhc_order: "",
      dhc_branch_order: "",
      shop_order: "",
      country_order: "",
      item_type_order: "",
      day_order: "",
      month_order: "",
      year_order: "",
      serial_number_order: "",
      character: "",
      year_type: "",
      year_char: "",
      selected_dhc_branch: "",
      certificate_prefix_text: "",
    },
    validationSchema: validation,
    enableReinitialize:true,
    validate: (values) => {
      let errors = {};
      if (values?.format_type === 2) {
        if (!values?.shop_id) {
          errors.shop_id = "*Required";
        }
      }
      if (certificationChecked) {
        if (!values?.character) {
          errors.character = "*Required";
        }
      }
      if (yearChecked) {
        if (!values?.year_type) {
          errors.year_type = "*Required";
        }
        if (values?.year_type?.id === "character") {
          if (!values?.year_char) {
            errors.year_char = "*Required";
          }
        } else {
          if (!values?.year) {
            errors.year = "*Required";
          }
        }
      }

      if(values?.dhc_branch) {
        if (!values?.certificate_prefix_text) {
            errors.certificate_prefix_text = "*Required";
          }
      }

      if (values?.serial_number_basis?.id === 2) {
        if (!values?.selected_dhc_branch) {
          errors.selected_dhc_branch = "*Required";
        }
        // if (!values?.certificate_prefix_text) {
        //   errors.certificate_prefix_text = "*Required";
        // }
      }

      return errors;
    },
    onSubmit: (values, {resetForm}) => {
      const orderArray = [
        { check_box_name: "dhc", order: values.dhc_order?.value },
        { check_box_name: "supplier", order: values.supplier_order?.value },
        {
          check_box_name: "price_or_code",
          order: values.price_or_code_order?.value,
        },
        {
          check_box_name: "certification",
          order: values.certification_order?.value,
        },
        { check_box_name: "dhc_branch", order: values.dhc_branch_order?.value },
        { check_box_name: "shop", order: values.shop_order?.value },
        { check_box_name: "country", order: values.country_order?.value },
        { check_box_name: "item_type", order: values.item_type_order?.value },
        { check_box_name: "day", order: values.day_order?.value },
        { check_box_name: "month", order: values.month_order?.value },
        { check_box_name: "year", order: values.year_order?.value },
        {
          check_box_name: "serial_number",
          order: values.serial_number_order?.value,
        },
      ];
      const prefixes = [];
      
      orderArray
        .filter((option) => option.order !== undefined)
        .sort((a, b) => (a.order > b.order ? 1 : -1))
        .forEach((item) => {
          if (item.order) {
            prefixes.push(item.check_box_name);
          }
        });
      let data = {
        lot_prefix_id: isEdit ? lotPrefixData?._id : "",
        status: values?.status?.id,
        shop_id: values?.shop_id?._id,
        serial_number: values?.serial_number,
        shop_lot_prefix:values?.shop_lot_prefix,
        dhc: dhcChecked,
        supplier: supplierChecked,
        price_or_code: priceOrCodeChecked,
        certification: certificationChecked,
        dhc_branch: dhcBranchChecked,
        shop: true,
        country: countryChecked,
        item_type: itemTypeChecked,
        day: dayChecked ? values?.day?.id : null,
        month: monthChecked ? values?.month?.id : null,
        year: yearChecked ? values?.year?.id : null,
        gold_based: goldBasedChecked,
        platinum_based: platinumBasedChecked,
        serial_number_basis: values?.serial_number_basis?.id,
        serial_number_reset: values?.serial_number_reset?.id,
        // prefix_order: prefixes,
        prefix_order:["serial_number", "shop"],
        format_type: values?.format_type,
        character: values?.character,
        year_type: values?.year_type?.id,
        year_character: values?.year_char,
        branch_id: values?.selected_dhc_branch?._id,
        branch_prefix:
          // values?.serial_number_basis?.id === 2 &&
          values?.certificate_prefix_text,
      };

      let newObj = Object.entries(data);
      newObj = newObj
        .filter(
          (item) => item[1] !== undefined && item[1] !== "" && item[1] !== null
        )
        .reduce((a, v) => ({ ...a, [v[0]]: v[1] }), {});

      updateLotPrefixData(newObj).then((response) => {
        if (response?.data?.status_code === 200) {
          handleCloseModal();
          if (isEdit) {
            toast.success("Lot Prefix Details Updated");
            
          } else {
            toast.success("New Lot Prefix Created");
          }
          dispatch(
            updateConfig((state) => {
              state.clearSelection = true;
              state.lotPrefixData = [];
            })
          );
          refetch();
          resetForm();
        } else if (response?.error?.data?.status_code === 422) {
          // displays backend errors
          const errors = response?.error?.data?.errors;
          Object.keys(errors).forEach((field) => {
            if (field === "gold or platinum based") {
              const temp = "gold_based";
              formik.setFieldError(
                temp,
                "Please choose either Gold or platinum based"
              );
            } else if (field === "prefix_order") {
              toast.error("The prefix order field is required");
            } else {
              formik.setFieldError(field, errors[field]);
              toast.error(response?.error?.data?.message)
            }
          });
          // resetForm()
        } else {
          toast.error("Something went wrong");
        }
      });
    },
  });


  // useEffect(() => {
  //   const orderArray = [
  //     { check_box_name: "dhc", order: formik?.values.dhc_order?.value },
  //     {
  //       check_box_name: "supplier",
  //       order: formik?.values.supplier_order?.value,
  //     },
  //     {
  //       check_box_name: "price_or_code",
  //       order: formik?.values.price_or_code_order?.value,
  //     },
  //     {
  //       check_box_name: "certification",
  //       order: formik?.values.certification_order?.value,
  //     },
  //     {
  //       check_box_name: "dhc_branch",
  //       order: formik?.values.dhc_branch_order?.value,
  //     },
  //     { check_box_name: "shop", order: formik?.values.shop_order?.value },
  //     { check_box_name: "country", order: formik?.values.country_order?.value },
  //     {
  //       check_box_name: "item_type",
  //       order: formik?.values.item_type_order?.value,
  //     },
  //     { check_box_name: "day", order: formik?.values.day_order?.value },
  //     { check_box_name: "month", order: formik?.values.month_order?.value },
  //     { check_box_name: "year", order: formik?.values.year_order?.value },
  //     {
  //       check_box_name: "serial_number",
  //       order: formik?.values.serial_number_order?.value,
  //     },
  //       {
  //       check_box_name: "shop_lot_prefix",
  //       order: formik?.values.shop_lot_prefix?.value,
  //     },
  //   ];

  //   const exampleTextArray = [];
  //   orderArray
  //     .filter((option) => option.order !== undefined)
  //     .sort((a, b) => (a.order > b.order ? 1 : -1))
  //     .forEach((item) => {
  //       if (item.order) {
  //         exampleTextArray.push(item.check_box_name);
  //       }
  //     });

  //   const updatedValues = exampleTextArray.map((item) =>
  //     item === "serial_number"
  //       ? goldBasedChecked
  //         ? "GB" + formik?.values?.serial_number
  //         : platinumBasedChecked
  //         ? "PB" + formik?.values?.serial_number
  //         : formik?.values?.serial_number
  //       : item
  //   );

  //   const concatenatedValue = updatedValues.join("");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   setExampleText(concatenatedValue.toUpperCase());
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formik?.values]);


  useEffect(() => {
  const orderArray = [
    { check_box_name: "dhc", order: formik?.values.dhc_order?.value },
    { check_box_name: "supplier", order: formik?.values.supplier_order?.value },
    { check_box_name: "price_or_code", order: formik?.values.price_or_code_order?.value },
    { check_box_name: "certification", order: formik?.values.certification_order?.value },
    { check_box_name: "dhc_branch", order: formik?.values.dhc_branch_order?.value },
    { check_box_name: "shop", order: formik?.values.shop_order?.value },
    { check_box_name: "country", order: formik?.values.country_order?.value },
    { check_box_name: "item_type", order: formik?.values.item_type_order?.value },
    { check_box_name: "day", order: formik?.values.day_order?.value },
    { check_box_name: "month", order: formik?.values.month_order?.value },
    { check_box_name: "year", order: formik?.values.year_order?.value },
    { check_box_name: "serial_number", order: formik?.values.serial_number_order?.value },
    { check_box_name: "shop_lot_prefix", order: formik?.values.shop_lot_prefix_order?.value },
  ];

  const exampleTextArray = [];

  orderArray
    .filter((option) => option.order !== undefined)
    .sort((a, b) => (a.order > b.order ? 1 : -1))
    .forEach((item) => {
      if (item.order) exampleTextArray.push(item.check_box_name);
    });

  const updatedValues = exampleTextArray.map((item) => {
    // handle serial number with gold/platinum prefix
    if (item === "serial_number") {
      const serial = formik?.values?.serial_number || "";
      if (goldBasedChecked) return `GB${serial}`;
      if (platinumBasedChecked) return `PB${serial}`;
      return serial;
    }

    // handle shop lot prefix
    if (item === "shop_lot_prefix") {
      return formik?.values?.shop_lot_prefix || "";
    }

    return ""; // for other items we can skip since you want only these two
  });

  // combine lot prefix + serial
  const prefix = formik?.values?.shop_lot_prefix || "";
  const serial = goldBasedChecked
    ? `GB${formik?.values?.serial_number || ""}`
    : platinumBasedChecked
    ? `PB${formik?.values?.serial_number || ""}`
    : formik?.values?.serial_number || "";

  const concatenatedValue = `${prefix}${serial}`.toUpperCase();

  setExampleText(concatenatedValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [formik?.values, goldBasedChecked, platinumBasedChecked]);


  const setOrderValue = (id, ordervalue) => {
    const result = optionsArray.find((value) => value.value === ordervalue);
    formik.setFieldValue(`${id}_order`, result);
  };

  const handleCheckboxChange = (e, setter, id, checkedValue) => {
    const { checked } = e.target;
    setter(checked);
    formik.setFieldValue(id, checked);
    if (checkedValue) {
      const fieldNameArr = `${id}_order`;
      delete selectedOrders[fieldNameArr];
      const newSlectedOrders = { ...selectedOrders };
      setSelectedOrders(newSlectedOrders);
      formik.setFieldValue(fieldNameArr, "");
    }
  };

  const handleInputChange = (fieldName) => (selectedOption) => {
    formik.setFieldValue(fieldName, selectedOption);
    const localSelectedOrders = { ...selectedOrders };
    localSelectedOrders[fieldName] = selectedOption?.value;
    setSelectedOrders(localSelectedOrders);
  };
  useEffect(() => {
    if (selectedOrders.length !== 0) {
      handleChangeFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrders]);

  const handleChangeFunction = () => {
    const selectedOrdersArray = Object.values(selectedOrders);
    const filteredOptionsArray = optionsArray.filter(
      (option) => !selectedOrdersArray.includes(option.value)
    );
    setFilteredOptions(filteredOptionsArray);
  };

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showAddCertificatePrefixModal = false;
      })
    );
  };

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const inputFields = [
    {
      label: "Shop",
      name: "shop_id",
      data: basicData?.data?.shop,
      valueFn: (option) => option?.name,
      keyFn: (option) => option?._id,
      value: formik?.values?.shop?._id,
      blurHandler: formik.handleBlur("shop_id"),
      changeHandler: (value) => formik?.setFieldValue("shop_id", value || null),
      error: getFieldError("shop_id"),
    },
    {
      label: "Serial number reset",
      name: "serial_number_reset",
      data: basicData?.data?.serial_number_reset,
      valueFn: (option) => option?.name,
      keyFn: (option) => option?.id,
      value: formik?.values?.serial_number_reset,
      blurHandler: formik.handleBlur("serial_number_reset"),
      changeHandler: (value) =>
        formik?.setFieldValue("serial_number_reset", value || null),
      error: getFieldError("serial_number_reset"),
    },
    {
      label: "Serial number basis",
      name: "serial_number_basis",
      data: basicData?.data?.serial_number_basis,
      valueFn: (option) => option?.name,
      keyFn: (option) => option?.id,
      value: formik?.values?.serial_number_basis,
      blurHandler: formik.handleBlur("serial_number_basis"),
      changeHandler: (value) =>
        formik?.setFieldValue("serial_number_basis", value || null),
      error: getFieldError("serial_number_basis"),
    },
  ];

  // useEffect(() => {
  //   formik?.setFieldValue(
  //     "certificate_prefix_text",
  //     formik?.values?.selected_dhc_branch?.certificate_prefix_text
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formik?.values?.selected_dhc_branch?._id]);

  return {
    formik,
    isEdit,
    formData: formData?.data,
    basicData: basicData?.data,
    countryData,
    dhcChecked,
    dhcBranchChecked,
    shopChecked,
    countryChecked,
    itemTypeChecked,
    dayChecked,
    monthChecked,
    yearChecked,
    goldBasedChecked,
    platinumBasedChecked,
    filteredOptions,
    exampleText,
    checkboxFields,
    inputFields,
    selectedOrders,
    lotPrefixData,
    handleCloseModal,
    getFieldError,
    handleInputChange,
    handleCheckboxChange,
    setDhcChecked,
    setDhcBranchChecked,
    setShopChecked,
    setCountryChecked,
    setItemTypeChecked,
    setDayChecked,
    setMonthChecked,
    setYearChecked,
    setGoldBasedChecked,
    setPlatinumBasedChecked,
    handleChangeFunction,
  };
};

export default useAddLotPrefix;
